import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { Trip } from '../../types/trip';


interface TourPlanProps {
  data: { plan: Trip['plan'] } | null;
  isExperience: boolean;
}

function TourPlan({ data, isExperience }: TourPlanProps) {
  const [showFormStates, setShowFormStates] = useState<boolean[]>([true]);

  useEffect(() => {
    if (data && data.plan) {
      setShowFormStates(Array(data.plan.length).fill(false));
    }
  }, [data]);

  const toggleForm = (index: number) => {
    setShowFormStates(prevState => {
      const newShowFormStates = [...prevState];
      newShowFormStates[index] = !newShowFormStates[index];
      return newShowFormStates;
    });
  };

  const handleOnClick = (index: number) => {
    if (!isExperience) {
      toggleForm(index);
    }
  };

  return (
    <div className='tourplan__container'>
      <h2>Tour Plan</h2>
      <div className="accordion">
        <ul className='tourplan__ul'>
          {data && data.plan && data.plan.map((item, index) => (
            <li key={index} className='tourplan__li'>
              <div className="accordion-item">
                <button
                  id={`accordion-button-${index}`}
                  aria-expanded={showFormStates[index]}
                  onClick={() => handleOnClick(index)}
                  className={isExperience ? 'experience' : ''}
                >
                  <div className='titulares'>
                    {!isExperience && (<span className="accordion-title">Día {item.day}</span>)}
                    <span className="accordion-subtitle">{item.title}</span>
                  </div>

                  {!isExperience && (
                    <FontAwesomeIcon
                      aria-hidden="true"
                      className={`icon ${showFormStates[index] ? 'rotate-180' : ''}`}
                      icon={faAngleDown}
                    />
                  )}
                </button>

                <div className={`accordion-content ${!isExperience ? showFormStates[index] ? 'expanded' : '' : 'expanded'}`}>
                  {!isExperience && (<h4 className='content__date'>{item.date}</h4>)}
                  <p className='content__description' dangerouslySetInnerHTML={{ __html: item?.description }}></p>

                  {item.activities && item.activities.length > 0 && (
                    <div className="box__hastag">
                      <ul className='hastag__list'>
                        {item.activities.map((activity, actIndex) => (
                          activity && (
                            <li key={actIndex}>
                              <p>{activity}</p>
                            </li>
                          )
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default TourPlan; 